<ng-container *ngIf="!isLoading else loading">
	<div class="card-block">
		<div class="card-title">
			<span translate>ecall-off.last-call-off-demand</span>
		</div>
		<ng-container *ngIf="ecallData else noEcallData">
			<div class="ecall-block-portal" *ngFor="let ecall of ecallData">
				<div class="grid-5">
					<div class="card-row">
						<mat-icon color="accent" class="header-margin-right"
									[svgIcon]="icon(ecall).id" [title]="icon(ecall).title"></mat-icon>
					</div>
					<div class="container-ordered">
						<span class="tag-tonnage">{{ (ecall.quantitySum ? ecall.quantitySum: 0) | copoNumber:'weight':'t'
							}}</span>
					</div>
					<div class="ecall-container-column">
						<span class="ecall-content-label" translate>ecall-off-creation-date</span>
						<span>{{(ecall.callOffCreationTimestamp ? ecall.callOffCreationTimestamp : UNDERSCORE) | copoDate:'date'}}</span>
					</div>
					<div class="ecall-container-column">
						<span class="ecall-content-label" translate>ecall-off.customer-call-off-reference</span>
						<span>{{ ecall.customerCallOffReference ? ecall.customerCallOffReference : UNDERSCORE
							}}</span>
					</div>
					<div class="ecall-container-column ecall-column-end mobile-align">
						<button type="button" mat-icon-button #menuOption="matMenuTrigger" [matMenuTriggerFor]="menu" class="ecall-circle-icon">
							<mat-icon color="accent" [ngClass]="{'dots-icon' : !menuOption.menuOpen}" svgIcon="md:more_vert"></mat-icon>
						</button>
						<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
							<button type="button" mat-menu-item [routerLink]="['/ecall-off/ecall/card/', ecall.supplierCallOffNumber]">
								<mat-icon class="drag-icon-active " svgIcon="md:eye"></mat-icon>
								<span translate>ecall-off.see-card</span>
							</button>
						</mat-menu>
					</div>
				</div>
			</div>
			<div class="card-block-footer">
				<button type="button" mat-button color="primary"
				[routerLink]="['/ecall-off/ecall/list/']">
					<span translate>delivery-tracking.view-details</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</button>
			</div>
		</ng-container>
		<ng-template #noEcallData>
			<div translate class="empty-page-text grid-column-one-full">order-tracking.no.result</div>
		</ng-template>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>